import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { BaseService } from './base/base.service';
import { AppConfig } from './app-config';

import { TransactionComparability } from '../models/transaction-comparability';

@Injectable()
export class TransactionsComparabilityService extends BaseService<TransactionComparability> {

  constructor(protected http: HttpClient, protected config: AppConfig) {
    super(http, config);
  }

  public getTransactionComparabilities(tbaId: number, filter?: string): Observable<any> {
    const apiUrl = this.applyQueryString(filter, `${this.getResourceUrl()}tba/${tbaId}`);

    return this.http.get<any>(apiUrl);
  }

  public getTransactionComparabilityOptions(): Observable<any> {
    return this.http.get(`${this.getResourceUrl()}options`);
  }

  public getTransactionComparabilityStatuses(): Observable<any> {
    return this.http.get(`${this.getResourceUrl()}statuses`);
  }

  public editTransactionComparabilityEvaluate(data: TransactionComparability): Observable<any> {
    return this.http.patch(
      `${this.getResourceUrl()}evaluate/${data.transactionComparabilityId}`,
      data
    );
  }

  public editTransactionAcceptance(data: TransactionComparability): Observable<any> {
    return this.http.patch(
      `${this.getResourceUrl()}acceptance/${data.transactionComparabilityId}`,
      data
    );
  }

  protected getResourceUrl(): string {
    return `${this.baseUrl}transactions-comparability/`;
  }
}
